import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import { Heading6 } from '@ui/Typography'
import { Button } from '@ui/components/Button'
import { CircleCheckIcon } from '@ui/icons/CircleCheck.icon'

import { Box } from '@shared/components/Box'

import styles from './TransactionSuccessDialogueTemplate.module.scss'

interface TransactionSuccessDialogueTemplateProps {
  title: string
  goBack?(): void
}

export const TransactionSuccessDialogueTemplate: React.FunctionComponent<
  PropsWithChildren<TransactionSuccessDialogueTemplateProps>
> = (props) => {
  const { children, title, goBack = () => {} } = props
  const { t } = useTranslation()

  return (
    <Box flex align='center' justify='center' fullWidth fullHeight mt='x32' alignSelf='center'>
      <Box
        className={styles.box}
        flex
        textAlign='center'
        direction='column'
        align='center'
        p='x24'
        radius='x12'
        gap='x16'
      >
        <CircleCheckIcon color='text-success-high-em' size={64} />
        <Heading6 className='has-text-centered' medium>
          {title}
        </Heading6>
        <Box flex align='center' direction='column'>
          {children}
        </Box>
        {goBack && (
          <Button.Primary fullWidth size='lg' onClick={goBack}>
            {t('OK')}
          </Button.Primary>
        )}
      </Box>
    </Box>
  )
}
